import _ from "lodash";
import { TOTALDEVICE, COUNTRIES, PARTICIPANTSTATUS, SITES } from "@/constants/config";
import { getContrast, primaryColorFnc } from "../visualization/data-management";
import { getShadeColor } from "../visualization/utils";

function getPlotToolText(type, percentColor) {
  const hexColor = primaryColorFnc();
  const defaultToolText = `<div class="study-engagement-metric-tooltip" style='color:${getContrast(getShadeColor(hexColor, percentColor))}; background-color:${getShadeColor(hexColor, percentColor)}'>
                <span>${type}</span><br/>
                <span class="data-label-text">$dataValue Mins</span><br>
                <span class="data-label-text">$displayValue Devices</span>
            </div>`;
  const totalToolText = `<div class="study-engagement-metric-tooltip" style='color:${getContrast(getShadeColor(hexColor, percentColor))}; background-color:${getShadeColor(hexColor, percentColor)}'>
            <span>$label</span><br/>
            <span class="data-label-text">$dataValue Mins</span><br>
            <span class="data-label-text">$displayValue Devices</span>
        </div>`;
  return type === "Total" ? totalToolText : defaultToolText;
}

const dataSources = {
  chart: {
    animation: "1",
    xaxisname: "Devices",
    yaxisname: "Duration (Minutes)",
    xAxisNameFontColor: "#959fa4",
    xAxisNameFont: "RobotoRegular",
    xAxisNameFontSize: "9px",
    labelFontSize: "10px",
    labelFont: "RobotoRegular",
    labelFontColor: "#a3a3a3",
    yAxisNameFontColor: "#a3a3a3",
    yAxisNameFont: "RobotoRegular",
    yAxisNameFontSize: "9px",
    yAxisValueFont: "RobotoRegular",
    yAxisValueFontSize: "10px",
    yAxisValueFontColor: "#a3a3a3",
    theme: "fusion",
    legendPosition: "right",
    legendItemFont: "RobotoRegular",
    legendItemFontSize: "10px",
    legendIconScale: "1.5",
    legendItemFontColor: "#666669",
    legendCaptionAlignment: "center",
    baseFontSize: "10",
    tooltipBorderAlpha: "0",
    toolTipBgAlpha: "0",
    showToolTipShadow: "0",
    divLineAlpha: "0",
    divLineDashed: "0",
    labelDisplay: "wrap",
    maxLabelHeight: "30",
    useEllipsesWhenOverflow: "1",
    maxColWidth: "42",
    plotHighlightEffect: "fadeout",
    plotSpacePercent: 30,
    reverseLegend: false,
    minimiseWrappingInLegend: true,
    showXAxisLine: true,
    showYAxisLine: true,
    xaxislinethickness: "1",
    yaxislinethickness: "1",
    xAxisLineColor: "#b0bac9",
    yAxisLineColor: "#b0bac9",
    chartBottomMargin: "0",
    xAxisNamePadding: "5",
    legendIconAlpha: 0,
    decimals: 3
  },
  annotations: {
    groups: [
      {
        id: "user-images",
        autoScale: 0,
        items: [
          {
            id: "device-ios-phone",
            type: "image",
            url: "static/img/device-ios-phone.png",
            x: "$legendStartX+7",
            y: "$legendStartY+8",
            // visible: 0,
            xScale: 17,
            yscale: 17
          },
          {
            id: "device-ios-tablet",
            type: "image",
            url: "static/img/device-ios-tablet.png",
            x: "$legendStartX+7",
            y: "$legendStartY+32",
            xScale: 17,
            yscale: 17
          },
          {
            id: "device-android-phone",
            type: "image",
            url: "static/img/device-android-phone.png",
            x: "$legendStartX+7",
            y: "$legendStartY+58",
            xScale: 17,
            yscale: 17
          },
          {
            id: "device-android-tablet",
            type: "image",
            url: "static/img/device-android-tablet.png",
            x: "$legendStartX+7",
            y: "$legendStartY+84",
            xScale: 17,
            yscale: 17
          }
        ]
      }
    ]
  },
  categories: [],
  dataset: []
};

const series2dOptions = {
  chart: {
    animation: "1",
    xaxisname: "Devices",
    yaxisname: "Duration (Minutes)",
    xAxisNameFontColor: "#959fa4",
    xAxisNameFont: "RobotoRegular",
    xAxisNameFontSize: "9px",
    labelFontSize: "10px",
    labelFont: "RobotoRegular",
    labelFontColor: "#a3a3a3",
    yAxisNameFontColor: "#a3a3a3",
    yAxisNameFont: "RobotoRegular",
    yAxisNameFontSize: "9px",
    yAxisValueFont: "RobotoRegular",
    yAxisValueFontSize: "10px",
    yAxisValueFontColor: "#a3a3a3",
    theme: "fusion",
    baseFontSize: "10",
    tooltipBorderAlpha: "0",
    toolTipBgAlpha: "0",
    showToolTipShadow: "0",
    divLineAlpha: "0",
    divLineDashed: "0",
    labelDisplay: "wrap",
    maxLabelHeight: "30",
    useEllipsesWhenOverflow: "1",
    maxColWidth: "42",
    plotHighlightEffect: "fadeout",
    plotSpacePercent: 30,
    showXAxisLine: true,
    showYAxisLine: true,
    xaxislinethickness: "1",
    yaxislinethickness: "1",
    xAxisLineColor: "#b0bac9",
    yAxisLineColor: "#b0bac9",
    chartBottomMargin: "0",
    xAxisNamePadding: "5",
    decimals: 3
  },
  data: []
};

function getLegendItem(deviceName, transparencyPercentage, primaryColor, ranking = 0) {
  let yPosition = 8;
  switch (ranking) {
    case 0:
      yPosition = 8;
      break;
    case 1:
      yPosition = 32;
      break;
    case 2:
      yPosition = 58;
      break;
    case 3:
      yPosition = 84;
      break;
    default:
      break;
  }
  const item = {
    id: deviceName.replace(/\s+/g, ""),
    type: "image",
    x: "$legendStartX+7",
    y: `$legendStartY+${yPosition}`,
    xScale: 17,
    yscale: 17
  };
  let icon = null;
  if (deviceName.toLowerCase().includes("android")) {
    const AndroidSvg = `<svg fill="none" width="100" height="100" viewBox="42.544 -.671 467.96 553.72" xmlns="http://www.w3.org/2000/svg"><path fill="${getShadeColor(
      primaryColor,
      transparencyPercentage
    )}" d="m76.774 179.141c-9.529 0-17.614 3.323-24.26 9.969s-9.97 14.621-9.97 23.929v142.914c0 9.541 3.323 17.619 9.97 24.266 6.646 6.646 14.731 9.97 24.26 9.97 9.522 0 17.558-3.323 24.101-9.97 6.53-6.646 9.804-14.725 9.804-24.266v-142.914c0-9.309-3.323-17.283-9.97-23.929s-14.627-9.969-23.935-9.969zm275.198-128.294 23.598-43.532c1.549-2.882.998-5.092-1.658-6.646-2.883-1.34-5.098-.661-6.646 1.989l-23.928 43.88c-21.055-9.309-43.324-13.972-66.807-13.972-23.488 0-45.759 4.664-66.806 13.972l-23.929-43.88c-1.555-2.65-3.77-3.323-6.646-1.989-2.662 1.561-3.213 3.764-1.658 6.646l23.599 43.532c-23.929 12.203-42.987 29.198-57.167 51.022-14.18 21.836-21.273 45.698-21.273 71.628h307.426c0-25.924-7.094-49.787-21.273-71.628-14.181-21.824-33.129-38.819-56.832-51.022zm-136.433 63.318c-2.552 2.558-5.6 3.831-9.143 3.831-3.55 0-6.536-1.273-8.972-3.831-2.436-2.546-3.654-5.582-3.654-9.137 0-3.543 1.218-6.585 3.654-9.137 2.436-2.546 5.429-3.819 8.972-3.819s6.591 1.273 9.143 3.819c2.546 2.558 3.825 5.594 3.825 9.137-.007 3.549-1.285 6.591-3.825 9.137zm140.086 0c-2.441 2.558-5.434 3.831-8.971 3.831-3.551 0-6.598-1.273-9.145-3.831-2.551-2.546-3.824-5.582-3.824-9.137 0-3.543 1.273-6.585 3.824-9.137 2.547-2.546 5.594-3.819 9.145-3.819 3.543 0 6.529 1.273 8.971 3.819 2.438 2.558 3.654 5.594 3.654 9.137 0 3.549-1.217 6.591-3.654 9.137zm-231.654 292.639c0 10.202 3.543 18.838 10.63 25.925 7.093 7.087 15.729 10.63 25.924 10.63h24.596l.337 75.454c0 9.528 3.323 17.619 9.969 24.266s14.627 9.97 23.929 9.97c9.523 0 17.613-3.323 24.26-9.97s9.97-14.737 9.97-24.266v-75.447h45.864v75.447c0 9.528 3.322 17.619 9.969 24.266s14.73 9.97 24.26 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.737 9.969-24.266v-75.447h24.928c9.969 0 18.494-3.544 25.594-10.631 7.086-7.087 10.631-15.723 10.631-25.924v-221.361h-305.09zm352.304-227.663c-9.309 0-17.283 3.274-23.93 9.804-6.646 6.542-9.969 14.578-9.969 24.094v142.914c0 9.541 3.322 17.619 9.969 24.266s14.627 9.97 23.93 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.725 9.969-24.266v-142.914c0-9.517-3.322-17.552-9.969-24.094-6.647-6.53-14.737-9.804-24.26-9.804z"/></svg>`;
    const AndroidEncoded = window.btoa(AndroidSvg);
    icon = `data:image/svg+xml;base64,${AndroidEncoded}`;
  } else if (deviceName.toLowerCase().includes("ios")) {
    const iosSvg = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="100" height="100" viewBox="0 0 456.008 560.035"><path fill="${getShadeColor(
      primaryColor,
      transparencyPercentage
    )}" d="M380.844 297.529c.787 84.752 74.349 112.955 75.164 113.314-.622 1.988-11.754 40.191-38.756 79.652-23.343 34.117-47.568 68.107-85.731 68.811-37.499.691-49.557-22.236-92.429-22.236-42.859 0-56.256 21.533-91.753 22.928-36.837 1.395-64.889-36.891-88.424-70.883-48.093-69.53-84.846-196.475-35.496-282.165 24.516-42.554 68.328-69.501 115.882-70.192 36.173-.69 70.315 24.336 92.429 24.336 22.1 0 63.59-30.096 107.208-25.676 18.26.76 69.517 7.376 102.429 55.552-2.652 1.644-61.159 35.704-60.523 106.559M310.369 89.418C329.926 65.745 343.089 32.79 339.498 0 311.308 1.133 277.22 18.785 257 42.445c-18.121 20.952-33.991 54.487-29.709 86.628 31.421 2.431 63.52-15.967 83.078-39.655"/></svg>`;
    const IosEncoded = window.btoa(iosSvg);
    icon = `data:image/svg+xml;base64,${IosEncoded}`;
  }
  item.url = icon;
  return item;
}

function GET_ACTIVITY_DEVICE_SERIES(rawData, choosenCountries = [], choosenSites = [], tabName = "") {
  const series = {};
  let series2d = [];

  // let initData = tabName === PARTICIPANTSTATUS ? [] : [{ value: 0 }]
  series["dataset"] = [];
  series["categories"] = [];

  if (!rawData || choosenCountries.length === 0 || choosenSites.length === 0) {
    return { series, series2d };
  }

  let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
  primaryColor = primaryColor || "#7f69d4";

  let dataTemp = {};
  const totalData = [];
  const deviceCategorySet = new Set();
  let elementSet = new Set(); // This is helper for sort Country and Sites
  if (tabName === PARTICIPANTSTATUS) {
    dataTemp = {
      Invited: [],
      Registered: [],
      Verified: [],
      Active: [],
      "Active with Modifications": []
    };
    elementSet = new Set(["Invited", "Registered", "Verified", "Active", "Active with Modifications"]); // this is the sorting logic for Status tab
  }
  let element;
  for (const countryName in rawData) {
    if (choosenCountries !== "all" && choosenCountries[0] !== "all" && !choosenCountries.includes(countryName)) {
      continue;
    }
    if (tabName === COUNTRIES) {
      element = countryName;
      elementSet.add(element);
      dataTemp[element] = [];
    }
    for (const siteName in rawData[countryName]) {
      if (choosenSites[0] !== "all" && !choosenSites.includes(siteName)) {
        continue;
      }
      if (tabName === SITES) {
        element = siteName;
        elementSet.add(element);
        dataTemp[element] = [];
      }
      for (const statusName in rawData[countryName][siteName]) {
        for (const deviceName in rawData[countryName][siteName][statusName]) {
          const deviceData = rawData[countryName][siteName][statusName][deviceName];
          deviceCategorySet.add(deviceName);
          const deviceIndex = totalData.findIndex(d => d.deviceName === deviceName);
          if (deviceIndex < 0) {
            const device = {
              deviceName,
              nDevice: deviceData.n_devices,
              avgSession: deviceData.avg_session,
              totalSession: deviceData.avg_session
            };
            totalData.push(device);
          } else {
            totalData[deviceIndex].nDevice += deviceData.n_devices;
            totalData[deviceIndex].totalSession += deviceData.n_devices * deviceData.avg_session;
            totalData[deviceIndex].avgSession = totalData[deviceIndex].totalSession / totalData[deviceIndex].nDevice;
          }

          //calculate data for Countries or Sites or Status Tab
          if (tabName !== TOTALDEVICE) {
            if (tabName === PARTICIPANTSTATUS) {
              element = statusName;
            }
            const deviceIndex2 = dataTemp[element].findIndex(d => d.deviceName === deviceName);
            if (deviceIndex2 < 0) {
              const device = {
                deviceName,
                nDevice: deviceData.n_devices,
                avgSession: deviceData.avg_session,
                totalSession: deviceData.avg_session
              };
              dataTemp[element].push(device);
            } else {
              dataTemp[element][deviceIndex2].nDevice += deviceData.n_devices;
              dataTemp[element][deviceIndex2].totalSession += deviceData.n_devices * deviceData.avg_session;
              dataTemp[element][deviceIndex2].avgSession = totalData[deviceIndex2].totalSession / totalData[deviceIndex2].nDevice;
            }
          }
        }
      }
    }
  }
  // TotalData always executed even if we process Countries/Sites/Status tabs. We need this data to define the highest device for sorting in other tabs
  const sortedTotalData = _.orderBy(totalData, ["avgSession", "nDevice", "deviceName"], ["desc", "desc", "asc"]);
  const totalDeviceData = [];
  sortedTotalData.forEach((totalData, index) => {
    const transparencyPercentage = (index + 1) * 20;
    const color = getShadeColor(primaryColor, transparencyPercentage);
    const tooltext = getPlotToolText("Total", transparencyPercentage);
    totalDeviceData.push({
      label: totalData.deviceName.replace("IOS", "iOS"),
      value: totalData.avgSession.toFixed(0),
      displayValue: totalData.nDevice,
      color,
      tooltext
    });
  });
  series2d = totalDeviceData;

  if (tabName !== TOTALDEVICE) {
    dataSources.annotations.groups[0].items = []; // reset legend icon
    const categories = [];
    const chartData = {};
    const elementArr = Array.from(elementSet);
    if (tabName !== PARTICIPANTSTATUS) {
      elementArr.sort();
    }
    for (const currentElement of elementArr) {
      categories.push({
        label: currentElement
      });
      sortedTotalData.forEach(device => {
        //In Each Status/ Countries / Sites tab, always sort by the highest average session. This is stored in sortedTotalData
        const { deviceName } = device;
        if (!chartData[deviceName]) {
          chartData[deviceName] = [];
        }
        const getElement = dataTemp[currentElement].find(e => e.deviceName === deviceName);
        chartData[deviceName].push({
          value: getElement ? getElement.avgSession.toFixed(0) : null, // if in some element (i.e in Active Tab there is no Android phone), fill with null value
          displayValue: getElement ? getElement.nDevice : null
        });
      });
    }

    sortedTotalData.forEach((device, index) => {
      const { deviceName } = device;
      const transparencyPercentage = (index + 1) * 20;
      series["dataset"][index] = {
        seriesname: deviceName.replace("IOS", "iOS"),
        color: getShadeColor(primaryColor, transparencyPercentage),
        plottooltext: getPlotToolText(deviceName.replace("IOS", "iOS"), transparencyPercentage),
        data: chartData[deviceName]
      };
      const item = getLegendItem(deviceName, transparencyPercentage, primaryColor, index);
      dataSources.annotations.groups[0].items.push(item);
    });
    series["categories"][0] = { category: [] };
    series.categories[0].category = categories;
  }

  return {
    series,
    series2d,
    deviceCategory: Array.from(deviceCategorySet),
    dataSources
  };
}

export { GET_ACTIVITY_DEVICE_SERIES, dataSources, series2dOptions };
